import React from 'react';
import menuStructure from 'content/SideMenu.yml';
import DocsMenuContent from './DocsMenuContent';

const DocsMenu: React.FC<React.HTMLAttributes<HTMLElement>> = () => (
	<DocsMenuContent items={menuStructure} depth={0} />
);

export default DocsMenu;
